// utils
import { useContent } from 'components/Page/page-hooks';

export default function useShowBreadcrumbs() {
  const content = useContent();

  return content?.page?.showBreadcrumbs ?? true;
}
